import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  eventRoot: {
    width: "100%",
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    cursor: "pointer",
    borderLeft: "8px solid white",
    "& .MuiCardContent-root": {
      paddingLeft: 0,
      paddingRight: theme.spacing(1),
      paddingTop: 0,
      paddingBottom: 0,
    },
    "&.Scheduled": {
      borderColor: "#4ba97e !important",
    },
    "&.Canceled": {
      borderColor: "#f96868 !important",
    },
    "&.Rejected": {
      borderColor: "#f96868 !important",
    },
    "&.Occurred": {
      color: "rgba(0, 0, 0, 0.26) !important",
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    },
    "&.ToConfirm": {
      borderColor: "#707070 !important",
    },
    "&.ToConfirmByEducator": {
      borderColor: "#707070 !important",
    },
  },
  eventTitle: {
    fontSize: 16,
  },
  tTruncate: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "295px",
  },
  guestBadge: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  smallAvatarIcon: {
    width: 22,
    height: 22,
  },
  confirmed: {
    color: theme.palette.success.dark,
  },
  educatorAvatar: {
    marginRight: theme.spacing(1.5),
  },
  eventDetails: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  eventDetail: {
    display: "flex",
  },
  eventDetailIcon: {
    fontSize: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  eventActions: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: theme.spacing(1.5),
  },
  eventAction: {
    display: "flex",
    "&:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  button: {
    cursor: "pointer",
  },
  rejectedWarningSection: {
    display: "flex",
  },
  rejectedEventErrorText: {
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
}));

export default useStyles;
